import { useTicketSubmit } from '@/hooks/sales/useTicket';
import { selectActiveTicket } from '@/redux/data/dataSlice';
import { useAppSelector } from '@/redux/hooks';
import { SaveFilled } from '@ant-design/icons';
import { Button, Input, Modal } from 'antd';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SaveSaleBtn = () => {
  const { t } = useTranslation();

  const activeTicket = useAppSelector(selectActiveTicket);

  const { saveSale } = useTicketSubmit();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState('');

  const handleSaveSale = useCallback(() => {
    if (!activeTicket) return;

    // only show modal if the ticket has not been saved to the backend
    if (activeTicket.savedToBackend) {
      saveSale(activeTicket.ID);
    } else {
      setIsModalOpen(true);
    }
  }, [activeTicket, saveSale]);

  const handleModalOk = useCallback(() => {
    if (!activeTicket) return;
    saveSale(activeTicket.ID, name);
    setIsModalOpen(false);
    setName('');
  }, [activeTicket, name, saveSale]);

  const handleModalCancel = useCallback(() => {
    setIsModalOpen(false);
    setName('');
  }, []);

  return (
    <>
      <Button
        block
        size="large"
        icon={<SaveFilled className="text-xs" />}
        className="h-8 lg:h-9 rounded-lg font-medium text-[10px] lg:text-xs"
        onClick={handleSaveSale}
      >
        {t('common:save')}
      </Button>
      <Modal
        title={t('common:save')}
        open={isModalOpen}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText={t('common:save')}
        cancelText={t('common:cancel')}
        centered
        destroyOnClose
      >
        <Input
          placeholder={t('common:enter_ticket_name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onPressEnter={handleModalOk}
          autoFocus
        />
      </Modal>
    </>
  );
};

export default SaveSaleBtn;
